/** Tworzy czytelny slug z nazw koszulki (polskie znaki → ASCII, małe litery, myślniki). */
export function slugifyKit(parts: (string | null | undefined)[]): string {
  return parts
    .filter(Boolean)
    .join(" ")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Link do koszulki w formie /kit/<uuid>-<slug>. Końcówka jest ignorowana
 * przy wyszukiwaniu (patrz extractKitId), więc stare linki bez sluga działają.
 */
export function kitPath(id: string, ...parts: (string | null | undefined)[]): string {
  const slug = slugifyKit(parts);
  return slug ? `/kit/${id}-${slug}` : `/kit/${id}`;
}

/** Wyciąga UUID z parametru adresu, ignorując ewentualną końcówkę sluga. */
export function extractKitId(param: string): string {
  return param.slice(0, 36);
}
